import RedeemablesListView from "@module/reedemablesListView";
import { useRouter } from 'next/router';

function RedeemablePurchaseView() {
    const router = useRouter();
    const type = router.query.pagepath ? router.query.pagepath[1] : '';
    return (
        <RedeemablesListView fromPage={""} type={type} userData={null} setShowUserRegistrationModal={null} />
    );
}

export default RedeemablePurchaseView;